/* eslint-disable @typescript-eslint/camelcase */
import { handleActions } from 'redux-actions';
import {
  MonitorState,
  PeriodCountAccess,
  EnvironmentsWithFailedZeroTrustResponse,
} from './interfaces';
import Types from './types';

const initialState: MonitorState = {
  isLoading: false,
  blockedEnvironmentsData: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  environmentHealthData: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  instanceStatusData: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  environmentAndCeleryQueueStatus: {
    blocked_queues: [],
    total_environments: 0,
    total_instances: 0,
    total_sessions: 0,
  },
  sessionsHistoryMonitorGraphFields: { metrics: [] },
  periodFilterSessions: PeriodCountAccess.LAST_15_DAYS,
  periodFilterHistory: PeriodCountAccess.LAST_15_DAYS,
  periodFilterInstances: PeriodCountAccess.LAST_15_DAYS,
  isLoadingSessionCard: false,
  clientsHistoryMonitorGraphFields: {
    total_created_clients: 0,
    created_clients_in_period: {
      count: 0,
      period_in_days: 0,
      growth_in_period_percent: 0,
    },
  },
  usersHistoryMonitorGraphFields: {
    total_created_users: 0,
    created_users_in_period: {
      count: 0,
      period_in_days: 0,
      growth_in_period_percent: 0,
    },
  },
  isLoadingClientCard: false,
  environmentsCostGraphFields: {
    total: '0',
    metrics: [],
  },
  monthlyEnvironmentsCostGraphFields: {
    metrics: [],
  },
  periodFilterEnvironmentsCost: PeriodCountAccess.LAST_15_DAYS,
  flavorsCostFields: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  flavorsCostPeriodFilter: PeriodCountAccess.LAST_15_DAYS,
  flavorsCostIsLoading: false,
  flavorEnvironmentsIsLoading: false,
  flavorEnvironmentsData: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  instancesWithSessionTimeout: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  environmentsWithFailedZeroTrust: {
    total_count: 0,
  } as EnvironmentsWithFailedZeroTrustResponse,
  isLoadingEnvironmentsWithFailedZeroTrust: false,
};

export default handleActions(
  {
    [Types.GET_BLOCKED_ENVIRONMENTS_REQUEST]: (state: MonitorState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_BLOCKED_ENVIRONMENTS_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      blockedEnvironmentsData: payload,
    }),
    [Types.GET_BLOCKED_ENVIRONMENTS_REJECTED]: (state: MonitorState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ENVIRONMENT_HEALTH_REQUEST]: (state: MonitorState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ENVIRONMENT_HEALTH_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      environmentHealthData: payload,
      isLoading: false,
    }),
    [Types.GET_ENVIRONMENT_HEALTH_REJECTED]: (state: MonitorState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_INSTANCE_STATUS_REQUEST]: (state: MonitorState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_INSTANCE_STATUS_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      instanceStatusData: payload,
      isLoading: false,
    }),
    [Types.GET_INSTANCE_STATUS_REJECTED]: (state: MonitorState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_REQUEST]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      isLoading: false,
      environmentAndCeleryQueueStatus: payload,
    }),
    [Types.GET_ENVIRONMENT_AND_CELERY_QUEUE_STATUS_REJECTED]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_REQUEST]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoadingEnvironmentsWithFailedZeroTrust: true,
    }),
    [Types.GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      isLoadingEnvironmentsWithFailedZeroTrust: false,
      environmentsWithFailedZeroTrust: payload,
    }),
    [Types.GET_ENVIRONMENTS_WITH_FAILED_ZERO_TRUST_REJECTED]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoadingEnvironmentsWithFailedZeroTrust: false,
    }),

    [Types.GET_SESSIONS_HISTORY_MONITOR_GRAPH_REQUEST]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoadingSessionCard: true,
    }),
    [Types.GET_SESSIONS_HISTORY_MONITOR_GRAPH_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      isLoadingSessionCard: false,
      sessionsHistoryMonitorGraphFields: payload,
    }),
    [Types.GET_SESSIONS_HISTORY_MONITOR_GRAPH_REJECTED]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoadingSessionCard: false,
    }),
    [Types.SET_PERIOD_FILTER_SESSIONS]: (state: MonitorState, { payload }) => ({
      ...state,
      periodFilterSessions: payload,
    }),
    [Types.SET_PERIOD_FILTER_INSTANCES]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      periodFilterSessions: payload,
    }),

    [Types.GET_ENVIRONMENTS_COST_MONITOR_GRAPH_REQUEST]: (
      state: MonitorState
    ) => ({
      ...state,
    }),
    [Types.GET_ENVIRONMENTS_COST_MONITOR_GRAPH_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      environmentsCostGraphFields: payload,
    }),
    [Types.GET_ENVIRONMENTS_COST_MONITOR_GRAPH_REJECTED]: (
      state: MonitorState
    ) => ({
      ...state,
    }),
    [Types.SET_PERIOD_FILTER_ENVIRONMENTS_COST]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      periodFilterEnvironmentsCost: payload,
    }),

    [Types.GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_REQUEST]: (
      state: MonitorState
    ) => ({
      ...state,
    }),
    [Types.GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      monthlyEnvironmentsCostGraphFields: payload,
    }),
    [Types.GET_MONTHLY_ENVIRONMENTS_COST_MONITOR_GRAPH_REJECTED]: (
      state: MonitorState
    ) => ({
      ...state,
    }),

    [Types.SET_PERIOD_CLIENT_HISTORY_FILTER]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      periodFilterHistory: payload,
    }),

    [Types.GET_CLIENTS_HISTORY_MONITOR_GRAPH_REQUEST]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoadingClientCard: true,
    }),
    [Types.GET_CLIENTS_HISTORY_MONITOR_GRAPH_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      isLoadingClientCard: false,
      clientsHistoryMonitorGraphFields: payload,
    }),
    [Types.GET_CLIENTS_HISTORY_MONITOR_GRAPH_REJECTED]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoadingClientCard: false,
    }),
    [Types.GET_USERS_HISTORY_MONITOR_GRAPH_REQUEST]: (state: MonitorState) => ({
      ...state,
      isLoadingClientCard: true,
    }),
    [Types.GET_USERS_HISTORY_MONITOR_GRAPH_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      isLoadingClientCard: false,
      usersHistoryMonitorGraphFields: payload,
    }),
    [Types.GET_USERS_HISTORY_MONITOR_GRAPH_REJECTED]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoadingClientCard: false,
    }),

    [Types.GET_FLAVORS_COST_MONITOR_REQUEST]: (state: MonitorState) => ({
      ...state,
      flavorsCostIsLoading: true,
    }),
    [Types.GET_FLAVORS_COST_MONITOR_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      flavorsCostFields: payload,
      flavorsCostIsLoading: false,
    }),
    [Types.GET_FLAVORS_COST_MONITOR_REJECTED]: (state: MonitorState) => ({
      ...state,
      flavorsCostIsLoading: false,
    }),
    [Types.SET_FLAVORS_COST_MONITOR_PERIOD_FILTER]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      flavorsCostPeriodFilter: payload,
    }),

    [Types.GET_FLAVOR_ENVIRONMENTS_REQUEST]: (state: MonitorState) => ({
      ...state,
      flavorEnvironmentsIsLoading: true,
    }),
    [Types.GET_FLAVOR_ENVIRONMENTS_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      flavorEnvironmentsIsLoading: false,
      flavorEnvironmentsData: payload,
    }),
    [Types.GET_FLAVOR_ENVIRONMENTS_REJECTED]: (state: MonitorState) => ({
      ...state,
      flavorEnvironmentsIsLoading: false,
    }),

    [Types.GET_INSTANCES_WITH_SESSION_TIMEOUT_REQUEST]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_INSTANCES_WITH_SESSION_TIMEOUT_FULFILLED]: (
      state: MonitorState,
      { payload }
    ) => ({
      ...state,
      instancesWithSessionTimeout: payload,
      isLoading: false,
    }),
    [Types.GET_INSTANCES_WITH_SESSION_TIMEOUT_REJECTED]: (
      state: MonitorState
    ) => ({
      ...state,
      isLoading: false,
    }),
  },
  initialState
);
